import React, { useEffect, useState, useRef, act, useInsertionEffect } from "react";
import { ReactComponent as Caller } from "../../assets/images/svg/Group 41662.svg";
import { ReactComponent as CutCall } from "../../assets/images/svg/CutCall.svg";
import { ReactComponent as AnswerCall } from "../../assets/images/svg/AnswerCall.svg";
import useFetch from "../../hooks/useFetch";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import Swal from "sweetalert2";
import { TopDisappearingMessage } from "../../utils/Common";
import useSocket from "../../hooks/useWebsocket";
import { AGENT_ACTIVITY } from "../../utils/ApiUrls";
import useAuth from "../../hooks/useAuth";
import song from "../../assets/music/ringtone.mp3";
import CallFeedback from "../Feedbacks/Feedback";
import Popup from "reactjs-popup";
import { FEEDBACK } from "../../utils/ApiUrls";
import { Card } from "@material-tailwind/react";
import ReconnectingPopup from "../../Popups/Reconnect";
import BreakReasons from "../../Popups/BreakReasons"
import RunningCampaigns from "../../pages/Agent/RunningCampaigns";
import axios from "../../utils/axios";
import { json, useNavigate } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import { useSIP } from "../../context/SIPContext";

const Call = (props) => {
  const [prevOnlineStatus,setPrevOnlineStatus] = useState("");
  const { auth,setAuth } = useAuth();
  const [fback, setfback] = useState(false);
  const navigate = useNavigate();

  const logout = useLogout();

  const [audioBlock,setAudioBlock] = useState(false);
  const [creditErrorAlreadyShown,setCreditErrorAlreadyShown] = useState(false);
  const [channelExceedErrorAlreadyShown,setChannelExceedErrorAlreadyShown] = useState(false);
  

  // ================  To Show Customer Number in the call Popup ================= //
  const [showCustomerNo, setCustomerNo] = useState(false);

  const initial_fbData = {
    id: "0",
    uid: props.call_id,
    agent_id: "",
    customer_id: "",
    answers: {},
    fbanswer: {},
    comment: "",
    folloup: "",
    dnc: false,
  };

  const [fbdata, setfbdata] = useState(initial_fbData);
  const [isReady, val, send, disconnect] = useSocket();
  const [isxReady, setIsReady] = useState(false);
  const [audio, setAudio] = useState(new Audio(song));
  const [isPlaying, setIsPlaying] = useState(false);
  const [incoming, setIncoming] = useState({});
  const [nextCallTime, setNextCallTime] = useState();
  const [feedbacksubmitted, setFeedbackSubmitted] = useState(false);

  // Running Campaigns //
  const [live_camps, setLiveCamps] = useState([])
  const [openCamps, setCamps] = useState(false)
  const [hasLoginPermission,setHasLoginPermission]=useState(false);

  let type = "";
  auth.roles?.includes("sys_admin") ? (type = "admin") : (type = "agent");

  const { unregister, callStatus, session, caller } = useSIP();


  const showNextCustomer = (closeInSeconds = 3) => {
    isCallActiveRef.current = false;
    setCall((prev) => ({
      ...prev,
      showcall: false,
      calltype: "Outgoing",
      customer: {},
    }));

    if (props.onlineStatus === "available") {
      TopDisappearingMessage(
        "top-start",
        closeInSeconds * 1000,
        "warning",
        "Next customer in " + closeInSeconds + " seconds"
      );

      setTimeout(() => {
        let camp_id = outgoing?.camp_details?.id;
        if (camp_id === undefined) {
          camp_id = localStorage.getItem("camp_id");
          setCampId(camp_id);
        }

        if (props.onlineStatus === "available") {
          if (camp_id) {
            let camprunn_data = {
              campaign_id: camp_id,
              agent_id: auth?.user_details?.user,
              type: "start",
            };
            setfback(false);
            send(
              JSON.stringify({
                data: camprunn_data,
                type: "call_customer",
              })
            );
          } else {
            TopDisappearingMessage(
              "top-start",
              5000,
              "warning",
              "Campaign Details Removed please do login again"
            );
          }
        }
      }, closeInSeconds * 1000);
    }
  };

  useEffect(() => {
    if (callStatus === 'active') {
      audio.pause()
    }
  }, [callStatus]);

  const signout = async () => {
    try {
      unregister()
      await logout("instant_logout");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  useEffect(() => {

    if (!isReady) return

    if (val?.action == "running_campaigns" && props.onlineStatus == "available") {
      if (val?.data && val.data.length > 0) {
        setCreditErrorAlreadyShown(false);
        setChannelExceedErrorAlreadyShown(false);

        // If the agent already has a current campaign and it's still live,
        // start it directly instead of asking them to choose again.
        const currentCampaignId = localStorage.getItem("currentCampaignId");
        const currentCampaignStillLive =
          currentCampaignId &&
          val.data.some((c) => String(c.id) === String(currentCampaignId));

        if (currentCampaignStillLive) {
          axios.post("/contactcentre/update_current_campaign/", {
            user_id: auth?.user_details?.id,
            camp_id: currentCampaignId,
          });
        } else {
          setCamps(true)
        }
      }
      console.log("data -----------> 22222222 ", val?.data)
      if (props.onlineStatus == "available") {
        setLiveCamps(val?.data)
      }
    }
    else if (val?.action == "no_assigned_campaigns" && props.onlineStatus == "available"){
      Swal.fire({
        title: "No Campaign Assigned",
        text: "You have no campaign to call",
        confirmButtonColor: "#3085d6",
        icon: 'warning'
      })
    }
    else if (val?.action == "no_running_campaigns" && props.onlineStatus == "available"){
      Swal.fire({
        title: "No Campaign Running",
        text: "You have no active campaign to call",
        confirmButtonColor: "#3085d6",
        icon: 'warning'
      }).then(() => {
        if (isReady) {
          send({ action: "" });
        }
      });
    }
    else if(val?.action == "disabled_login_actication"){
     
      Swal.fire({
        title: "Login Failed",
        text: `User is not allowed to login. Please Contact Admin to get access.`,
        confirmButtonColor: "#3085d6",
        icon: 'error'
      })
      
      setAuth((prev) => ({
        ...prev,
        permissions: {
          data: val?.data?.permissions
        }
      }));
      // signout();
    }
    
  }, [val?.action, props.onlineStatus])

  // useEffect(() => {
  //   if (!hasLoginPermission && type === "agent") {
  //     Swal.fire({
  //       title: "Login Failed",
  //       text: `User is not allowed to login. Please Contact Admin to get access.`,
  //       confirmButtonColor: "#3085d6",
  //       icon: 'error'
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         signout();
  //       }
  //     });
  //   }
  // }, [val?.data?.permissions, type]);

  const outgoingInitial = {
    camp_details: {},
    channel_unavailable: false,
  };
  const Initialcallstate = {
    showcall: false,
    customer: {},
    call_id: "",
    calltype: "",
    callstatus: "initialized",
  };

  const [outgoing, setOutgoing] = useState(outgoingInitial);
  const [call, setCall] = useState(Initialcallstate);
  // Tracks whether a call is genuinely in progress (set true on call start,
  // false only when the call actually ends). Used as a backup to restore
  // showcall if it ever gets hidden mid-call instead of at real call end.
  const isCallActiveRef = useRef(false);
  const [timer, setTimer] = useState("00:00");
  const [wssocket, setWssocket] = useState();
  const ws = useRef(null);
  const fetchData = useFetch();

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
  });

  useEffect(() => {
    // if (["unavailable", "break"].includes(props.onlineStatus)) {
    //   console.log("Agent Status is Unavailable");
    //   setOutgoing((prev) => {
    //     return { ...prev, camp_details: {}, channel_unavailable: false };
    //   });

    //   setCall(Initialcallstate);

    //   TopDisappearingMessage(
    //     "top-start",
    //     2000,
    //     "warning",
    //     "You are not available to make calls",
    //     false
    //   );
    // }

    (async () => {
      if (props.onlineStatus === "initial_status") {
        return;
      }
      console.log("ONLINE STATUS    :: ", props.onlineStatus);
      if (props.onlineStatus !== "break" || (props.onlineStatus === "break" && localStorage.getItem("isRefresh") === "true")) {
        try {
            let breakReason = null;
            if (props.onlineStatus === "break") {
                breakReason = localStorage.getItem("breakReason","") || "";
            }
            const res_data = await fetchData(
              "post",
              {
                status: props.onlineStatus,
                usertype: "agent",
                reason: breakReason,
              },
              AGENT_ACTIVITY
            );

            // alert(JSON.stringify(res_data));

            if (res_data?.status !== "success") {
              throw new Error(res_data?.message|"Status Update Failed");
            }

            localStorage.setItem("onlineStatus", props.onlineStatus);
            localStorage.setItem("breakReason", breakReason);
            localStorage.setItem("isRefresh", "false");
            // TopDisappearingMessage(
            //   "top-start",
            //   2000,
            //   "warning",
            //   res_data?.message, // "unavailable"
            //   false
            // );
            // alert(props.onlineStatus)
            if (["unavailable", "break"].includes(props.onlineStatus)) {
              console.log("Agent Status is Unavailable");
              setOutgoing((prev) => {
                return { ...prev, camp_details: {}, channel_unavailable: false };
              });

              isCallActiveRef.current = false;
              setCall(Initialcallstate);
              Swal.close();

              TopDisappearingMessage(
                "top-start",
                2000,
                "warning",
                "You are not available to make calls",
                false
              );
            }

            setPrevOnlineStatus(props.onlineStatus)
            props.setOnlineStatusColour(props.onlineStatus)
            
          } catch (err) {
            console.error("Agent activity change:", err);

            props.setOnlineStatus(prevOnlineStatus);
            
            Swal.fire({
              title: "Status Change Failed",
              text: "Unable to Change Status. Please try again",
              confirmButtonColor: "#3085d6",
              icon: "warning",
            });
          }


      }
    })();
  }, [props.onlineStatus]);

  const [manualCallData, setManualCallData] = useState();

  ////------------------  Re Call --------------------/////
  const [recall, setRecall] = useState(props.callType);
  useEffect(() => {
    if (props.callType === "recall") {
      isCallActiveRef.current = true;
      setCall((prev) => {
        return {
          ...prev,
          callstatus: "Outgoing",
          showcall: true,
          customer: props.customerDetails,
        };
      });

    if(!audioBlock){
      audio.play().catch(()=>{});
    }
    }
  }, [props.customerDetails, recall]);

  /////----------------------- End ------------------------////
  const [campId, setCampId] = useState("");

  useEffect(() => {
    if (disconnect == false) {
      TopDisappearingMessage(
        "top-start",
        2000,
        "success",
        "Reconnected",
        true
      );
    }
  }, [disconnect])

  useEffect(() => {
    console.log("isReady --------------------->    ", isReady)
    if (isReady) {
      let camp_id = outgoing?.camp_details?.id;
      if (camp_id === undefined) {
        camp_id = localStorage.getItem("camp_id");
        setCampId(camp_id);
      }

      if (props.onlineStatus === "available") {
        console.log("CAMPAIGN ID ----------- :", camp_id);

        if (camp_id) {
          let camprunn_data = {
            campaign_id: camp_id,
            agent_id: auth?.user_details?.user,
            type: "start",
          };
          send(
            JSON.stringify({
              data: camprunn_data,
              type: "call_customer",
            })
          );
        }
      }
    }

  }, [isReady])

  const CampaignStartPopUp = (data, call_type) => {
    let campaign_data = data?.camp_details;
    setCampId(campaign_data.id);
    localStorage.setItem("camp_id", campaign_data.id);
    localStorage.setItem('creditErrorAlreadyShown',"false");
    localStorage.setItem('channelExceedErrorAlreadyShown',"false");
    setOutgoing((prev) => {
      return { ...prev, camp_details: campaign_data };
    });
    let timerInterval;
    let closeInSeconds = parseInt(
      data?.camp_details?.call_intervel_time || 5
    );
    let camp_name = data?.camp_details?.name;
    let camp_id = data?.camp_details?.id;

    localStorage.setItem(
      "camp_details",
      JSON.stringify(campaign_data)
    );

    // setCreditErrorAlreadyShown(true);
    
    Swal.fire({
      title: "<h2 style='color:#6BC698'>" + camp_name + "</h5>",
      html: "Campaign Will Start in <strong></strong> seconds",
      timer: closeInSeconds * 1000,
      timerProgressBar: true,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
        let text_con = Swal.getHtmlContainer().querySelector("strong");
        if (text_con) {
          timerInterval = setInterval(() => {
            text_con.textContent = (Swal.getTimerLeft() / 1000).toFixed(0);
          }, 100);
        }
      },
      willClose: () => {
        val.action = ""
        clearInterval(timerInterval);
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
        let consumer_type;
        if (call_type === "progressive_dialer") {
          consumer_type = "progressive_dialer_start";
        } else if (call_type === "predictive_dialer") {
          consumer_type = "predictive_dialer_start";
        } else {
          consumer_type = "call_customer";
        }

        const camp_runn_data = {
          campaign_id: camp_id,
          agent_id: auth?.user_details?.user,
          type: "start",
        };
        const payload = {
          data: camp_runn_data,
          type: consumer_type,
        };
        if (data?.camp_details?.campaign_mode !== "auto") {
          setManualCallData(camp_runn_data);
          localStorage.setItem(
            "manualCallData",
            JSON.stringify(camp_runn_data)
          );
        }
        send(JSON.stringify(payload));
      }
    });
  }


  useEffect(() => {
    const data = val?.data;
    const action = val?.action;

    console.log("DATA ------------ : ", data);

    console.log("ACTION ---------- : ", action);

    console.log("AGENT STATUS --------- : ", props.onlineStatus);

    const requestCallCustomer = () => {
      console.log(data, "Outgoing When requestCallCustomer     :   ", outgoing);

      console.log("CAMPAIGN ID ---------> : ", campId);

      let camp_id = outgoing?.camp_details?.id;

      console.log(
        "ONLINE STATUS WHEN REQUESTCALLCUSTOMER  : ",
        props.onlineStatus
      );

      if (camp_id === undefined) {
        camp_id = localStorage.getItem("camp_id");
        setCampId(camp_id);
      }

      if (props.onlineStatus === "available") {
        console.log("CAMPAIGN ID ----------- :", camp_id);

        if (camp_id) {
          let camprunn_data = {
            campaign_id: camp_id,
            agent_id: auth?.user_details?.user,
            type: "start",
          };
          console.log("NEXT CALL CUSTOMER DATA :", camprunn_data);
          console.log("ACTION 2 -------> : ", action);

          if (action === "call_status") {
            setfback(false);
            send(
              JSON.stringify({
                data: camprunn_data,
                type: "call_customer",
              })
            );
          } else {
            console.log("call status is : ", action);
          }
        } else {
          TopDisappearingMessage(
            "top-start",
            5000,
            "warning",
            "Campaign Details Removed please do login again"
          );
        }
      }
    };

    if (action === "new_customer") {
    }

    if (action === "campaign_start") {
      if (props.onlineStatus === "available") {
        CampaignStartPopUp(data, "auto_dialer")
      }
    }

    if (action === "campaign_stop") {
      setOutgoing((prev) => {
        return { ...prev, camp_details: {} };
      });

      localStorage.removeItem("campaign_id");
      localStorage.removeItem("camp_details");

      Swal.fire({
        title: "",
        text: data.message,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "CHECK OTHER CAMPAIGN RUNNING",
        icon:'warning'
      }).then((result) => {
        if (result.isConfirmed) {
          let user_id = auth?.user_details?.user;
          send(
            JSON.stringify({
              data: { user: user_id },
              type: "chcek_any_camp_running",
            })
          );
        }
      });
    }

    if (action === "campaign_complete") {
      setOutgoing((prev) => {
        return { ...prev, camp_details: {} };
      });
      localStorage.removeItem("camp_details");

      Swal.fire({
        icon: "success",
        title: "Campaign is Completed",
        timer: 3000,
        timerProgressBar: true,
        showConfirmButton: true,
        confirmButtonText: "Done",
        confirmButtonColor: "#3085d6",
      });
    }

    if (action === "no_channel") {
      let type = data?.type;

      if (type === "no_channel") {
        setOutgoing((prev) => {
          return { ...prev, channel_unavailable: true };
        });

        if (outgoing.channel_unavailable) {
          console.log("Requesting Another Call");

          Toast.fire({
            icon: "warning",
            title: "Channel Busy",
          });

          requestCallCustomer();
        } else {
          Swal.fire({
            title: "",
            text: data.message,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Retry",
            icon:'warning'
          }).then((result) => {
            if (result.isConfirmed) {
              requestCallCustomer();
            }
          });
        }
      } else {
        Swal.fire({
          title: "",
          text: data.message,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Retry",
          icon:'warning'
        }).then((result) => {
          if (result.isConfirmed) {
            requestCallCustomer();
          }
        });
      }
    }

    if(localStorage.getItem('creditErrorAlreadyShown')==="false"){

      console.log(`creditErrorAlreadyShown : ${creditErrorAlreadyShown}`)
      
      let type = data?.type;

      // if(type==="no_credit"){
      if(action==="no_credit"){
        // setOutgoing((prev)=>{
        //   return {...prev,channel_unavailable:true};
        // });
        setCreditErrorAlreadyShown(true);
        
        Swal.fire({
          title:"",
          text:data.message,
          showConfirmButton:true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
          icon:"warning",
          willClose: ()=>{
            console.log(`creditErrorAlreadyShown status on alert close : ${creditErrorAlreadyShown}`)
            localStorage.setItem('creditErrorAlreadyShown',"true");
          }
        })
      }
    }

    // channel exceed alert
    if(localStorage.getItem("channelExceedErrorAlreadyShown")!=="true"){
      console.log(`channelExceedErrorAlreadyShown : ${channelExceedErrorAlreadyShown} action : ${action}`)

      if(action==="no_channel" || action==="channel_error"){
        setChannelExceedErrorAlreadyShown(true);

        Swal.fire({
          title:"",
          text:data.message,
          showConfirmButton:true,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
          icon:"warning",
          willClose: ()=>{
            console.log(`channelExceedErrorAlreadyShown status on alert close : ${channelExceedErrorAlreadyShown}`)
            localStorage.setItem('channelExceedErrorAlreadyShown',"true");
          }
        })
      }
    }


    // --------------------------------------------------------------------------------------------------------------------------- //

    // PROGRESSIVE DIALER //

    if (action === "progressive_dialer_agent_available") {
      if (props.onlineStatus === "available") {
        CampaignStartPopUp(data, "progressive_dialer")
      }
    }

    if (action === "progressive_dialer_start") {
      if (data?.camp_details?.campaign_mode === "auto") {
        setfback(!fback);
      }
      localStorage.setItem("camp_id", data.customer_details.campaign);
      setfbdata(initial_fbData);
      isCallActiveRef.current = true;
      setCall((prev) => {
        return {
          ...prev,
          callstatus: data.callstatus,
          call_id: data.uid,
          showcall: true,
          calltype: "Outgoing",
          customer: data.customer_details,
        };
      });
      setfbdata((prevState) => {
        return { ...prevState, uid: data.uid };
      });

      if(!audioBlock){
        audio.play().catch(()=>{});
      }
    }

    if (action === "progressive_call_status") {
      if (data.callstatus === "answerd") {
        audio.pause();
        setCall((prev) => {
          return { ...prev, callstatus: data?.status };
        });
      } else if (data.callstatus === "end") {
        audio.pause();
        isCallActiveRef.current = false;
        setCall((prev) => {
          return { ...prev, callstatus: data?.status };
        });
        setTimeout(function () {
          setCall((prev) => {
            return {
              ...prev,
              showcall: false,
              calltype: "Outgoing",
            };
          });
          if (props.onlineStatus === "available") {
            let camp_id = outgoing?.camp_details?.id;
            if (camp_id == undefined) {
              camp_id = localStorage.getItem("camp_id");
            }
            if (camp_id) {
              let camprunn_data = {
                campaign_id: camp_id,
                agent_id: auth?.user_details?.user,
                type: "start",
              };
              send(
                JSON.stringify({
                  data: camprunn_data,
                  type: "progressive_dialer_start",
                })
              );
            }
          }
        }, 3000);
      } else {
      }
    }

    if (action === "progressive_call_completed" || action === "predictive_call_completed") {
      if (data.callstatus === "answerd") {
        audio.pause();
        setCall((prev) => {
          return { ...prev, callstatus: data?.status };
        });
      } else if (data.callstatus === "end") {
        audio.pause();
        isCallActiveRef.current = false;
        setCall((prev) => {
          return { ...prev, callstatus: data?.status };
        });
        setTimeout(function () {
          setCall((prev) => {
            return {
              ...prev,
              showcall: false,
              calltype: "Outgoing",
              customer: {},
            };
          });
        }, 3000);
      }
    }

    // END PROGRESSIVE DIALER //

    // -------------------------------------------------------------------------------------------------------------------------------//

    //  PREDICTIVE DIALER //
    if (action === "predictive_dialer_agent_available") {
      if (props.onlineStatus === "available") {
        CampaignStartPopUp(data, "predictive_dialer")
      }
    }

    if (action === "predictive_dialer_start") {
      if (data?.camp_details?.campaign_mode === "auto") {
        setfback(!fback);
      }
      localStorage.setItem("camp_id", data.customer_details.campaign);
      setfbdata(initial_fbData);
      isCallActiveRef.current = true;
      setCall((prev) => {
        return {
          ...prev,
          callstatus: data.callstatus,
          call_id: data.uid,
          showcall: true,
          calltype: "Outgoing",
          customer: data.customer_details,
        };
      });
      setfbdata((prevState) => {
        return { ...prevState, uid: data.uid };
      });
      // audio.pla
    }

    if (action === "predictive_call_status") {
      if (data.callstatus === "answerd") {
        audio.pause();
        setCall((prev) => {
          return { ...prev, callstatus: data?.status };
        });
      } else if (data.callstatus === "end") {
        audio.pause();
        isCallActiveRef.current = false;

        setCall((prev) => {
          return { ...prev, callstatus: data?.status };
        });
        setTimeout(function () {
          setCall((prev) => {
            return {
              ...prev,
              showcall: false,
              calltype: "Outgoing",
            };
          });
          if (props.onlineStatus === "available") {
            let camp_id = outgoing?.camp_details?.id;
            if (camp_id == undefined) {
              camp_id = localStorage.getItem("camp_id");
            }
            if (camp_id) {
              let camprunn_data = {
                campaign_id: camp_id,
                agent_id: auth?.user_details?.useragent,
                type: "start",
              };
              send(
                JSON.stringify({
                  data: camprunn_data,
                  type: "predictive_dialer_start",
                })
              );
            }
          }
        }, 3000);
      } else {
      }
    }

    // END PREDICTIVE DIALER //

    // ---------------------------------------------------------------------------------------------------------------------------- //

    if (action === "call_customer") {
      if (outgoing?.camp_details?.campaign_mode === "auto") {
        setfback(!fback);
      }
      setfbdata(initial_fbData);

      setCustomerNo(data.customerNumPermission);
      isCallActiveRef.current = true;
      setCall((prev) => {
        return {
          ...prev,
          callstatus: data.callstatus,
          call_id: data.uid,
          showcall: true,
          calltype: "Outgoing",
          customer: data.customer_details,
        };
      });

      setfbdata((prevState) => {
        return { ...prevState, uid: data.uid };
      });

      setOutgoing((prev) => {
        return { ...prev, channel_unavailable: false };
      });

      audio
        .play()
        .catch((error) => console.error("Failed to play audio:", error));
    }

    if (action === "call_manual_customer") {
      console.log(
        data.customer_details,
        "===================CALL MANUAL CALLING====================",
        data
      );

      setCustomerNo(data.customerNumPermission);

      isCallActiveRef.current = true;
      setCall((prev) => {
        return {
          ...prev,
          callstatus: data.callstatus,
          call_id: data.uid,
          showcall: true,
          calltype: "Outgoing",
          customer: data.customer_details,
        };
      });
    }

    if (action === "call_status") {
      console.log("DATA CALL STATUS ------------- ", data.callstatus);
      if (data.callstatus === "answerd") {
        console.log("========function to show the connected time");
        audio.pause();
        setCall((prev) => {
          return { ...prev, callstatus: data?.status };
        });
      } else if (data.callstatus === "end") {
        audio.pause();
        isCallActiveRef.current = false;

        // Next Call in manual call ...

        if (outgoing.camp_details.campaign_mode == "manual") {
          console.log("feedback submitted ----> : ", feedbacksubmitted);
          if (feedbacksubmitted) {
            console.log("submitted !!!!!!!!!");
            setCall((prev) => {
              return { ...prev, callstatus: data?.status };
            });

            setTimeout(function () {
              setCall((prev) => {
                return {
                  ...prev,
                  showcall: false,
                  calltype: "Outgoing",
                  customer: {},
                };
              });

              if (props.onlineStatus === "available") {
                console.log("AVAILABLE     3");
                let camp_id = outgoing?.camp_details?.id;

                let closeInSeconds = data.closeInSeconds * 1000;
                let timerInterval = data.closeInSeconds;

                TopDisappearingMessage(
                  "top-start",
                  closeInSeconds,
                  "warning",
                  "Next customer in " + timerInterval + " seconds"
                );

                setTimeout(function () {
                  requestCallCustomer();
                }, closeInSeconds);
              }
            }, 3000);
          }
        }

        // Next call generate in auto call

        if (outgoing.camp_details.campaign_mode == "auto") {
          const closeInSeconds = data.closeInSeconds * 1000;
          const timerInterval = data.closeInSeconds;

          console.log("closeInSeconds  : ", closeInSeconds)
          console.log("timerInterval   : ", timerInterval)

          TopDisappearingMessage(
            "top-start",
            closeInSeconds,
            "warning",
            "Next customer in " + timerInterval + " seconds"
          );

          // Update UI immediately - no delay
          setCall((prev) => {
            return {
              ...prev,
              callstatus: data?.status,
              showcall: false,
              calltype: "Outgoing",
              customer: {}
            };
          });

          // Request next call immediately - backend handles the delay
          setTimeout(() => {
            if (props.onlineStatus === "available") {
              requestCallCustomer();
            }
          }, closeInSeconds);
        }
      }
    }
    if (action === "agent_customer_completion") {
      localStorage.removeItem("camp_details");
      Swal.fire({
        title: "Customer Queue Completed",
        text: data?.message ||
          "No more assigned or available customers remain for you in this campaign.",
        icon: "info",
        confirmButtonColor: "#3085d6",
      });
      setOutgoing((prev) => ({
        ...prev,
        camp_details: {},
      }));
      setCall((prev) => ({
        ...prev,
        showcall: false,
        calltype: "Outgoing",
        customer: {},
      }));
    }
  }, [val, props.onlineStatus, feedbacksubmitted]);

  // Backup plan: showcall should only turn false when the call actually ends.
  // If it gets hidden while isCallActiveRef is still true (call in progress),
  // that's not a real end - bring the popup back.
  useEffect(() => {
    if (!call.showcall && isCallActiveRef.current) {
      setCall((prev) => ({ ...prev, showcall: true }));
    }
  }, [call.showcall]);

  useEffect(()=>{
    if(props.onlineStatus==="available"){
      setCreditErrorAlreadyShown(false);
      setChannelExceedErrorAlreadyShown(false);
    }
  },[props.onlineStatus])

  useEffect(() => {
    const savedCamp = localStorage.getItem("camp_details");

    if (savedCamp) {
      setOutgoing(prev => ({
        ...prev,
        camp_details: JSON.parse(savedCamp)
      }));
    }
  }, []);

  const callCustomer = () => {
    console.log("manualCallData", manualCallData);
    const manualData = manualCallData || JSON.parse(localStorage.getItem("manualCallData"));

    if (!manualData) {
      Swal.fire("Error", "Campaign data not found", "error");
      return;
    }
    send(
      JSON.stringify({
        data: manualData,
        type: "call_customer",
        call_mode: "manualcall",
      })
    );

    setOutgoing((prev) => {
      return { ...prev, channel_unavailable: false };
    });

    if(!audioBlock){
      audio.play().catch(()=>{});
    }
  };

  return (
    <>
      <div
        className={`relative ${call?.showcall ? "" : "hidden"} w-full sm:w-20`}
      >
        <Popup
          open={fback}
          modal
          nested
          position="center center"
          contentStyle={{ width: "0px", marginTop: "-10px" }}
        >
          {(close) => (
            <CallFeedback
              showNextCustomer={showNextCustomer}
              setfback={setfback}
              close={close}
              customer={call.customer}
              call_id={call.call_id}
              camp_data={outgoing.camp_details}
              FBdata={fbdata}
              showCustomerNo={showCustomerNo}
              setFBdata={setfbdata}
              setFeedbackSubmitted={setFeedbackSubmitted}
            />
          )}
        </Popup>

        {/* Reconnecting popup */}
        {/* <Popup
          open={disconnect}
          modal
          nested
          position="center center"
          contentStyle={{ width: "0px", marginTop: "-10px" }}
        >
          {(close) => (
            <ReconnectingPopup
              setfback={setfback}
              close={close}
            />
          )}
        </Popup> */}

        {/* Live campaigns popup */}
        <Popup
          open={openCamps}
          modal
          nested
          position="center center"
          contentStyle={{ width: "380px", padding: 0, borderRadius: "14px", border: "none" }}
          overlayStyle={{ background: "rgba(0,0,0,0.5)" }}
        >
          {(close) => (
            <RunningCampaigns
              live_campaigns={live_camps}
              setCamps={setCamps}
              close={close}
            />
          )}
        </Popup>

        <div
          onClick={() => setfback(!fback)}
          className="fixed bottom-4 sm:top-1/2 lg:top-1/2 w-full sm:w-auto sm:left-1/2 transform sm:-translate-x-1/2 lg:left-[60%] right-0 p-4"
        >
          <Card className="bg-white rounded-lg shadow-lg p-4 w-full max-w-sm sm:max-w-md lg:max-w-lg">
            <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6">
              <div className="flex justify-center items-center w-16 h-16 sm:w-20 sm:h-20">
                <Caller />
              </div>
              <div className="text-center sm:text-left text-md font-bold flex-1">
                {call?.customer?.customer_name || call.customer.customer_phone_number}
                <br />
                {showCustomerNo ? "" : (
                  <span className="inline-flex items-center gap-1">
                    {call.customer.customer_phone_number}
                    <button
                      type="button"
                      title="Copy phone number"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigator.clipboard.writeText(call.customer.customer_phone_number);
                        TopDisappearingMessage(
                          "top-start",
                          1500,
                          "success",
                          "Phone number copied"
                        );
                      }}
                      className="p-0.5 hover:bg-gray-200 rounded"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-4 h-4 text-gray-500"
                      >
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                      </svg>
                    </button>
                  </span>
                )}
                <div className="mt-2 text-gray-500">
                  <div className="text-sm">{call?.calltype}</div>
                  <div>{call?.callstatus}</div>
                </div>
              </div>
              {outgoing?.camp_details?.campaign_mode === "manual" && (
                <button
                  className="hover:bg-green-200 text-white rounded-full"
                  onClick={() => callCustomer()}
                >
                  <AnswerCall className="w-6 h-6 sm:w-10 sm:h-10" />
                </button>
              )}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};

export default React.memo(Call);
